import { IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import { createPlanPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { MAX_TO, type PriceTier } from '@vy/types';
import { CloseIcon } from '../../../../../../../components/icons';
import { getToDisplayValue } from './edit-tiers-table-column-utils';
import type { UsageProductVariantTableRow } from './usage-product-variant-table-edit-types/usage-product-variant-table-row';

export interface EditTiersTableDisplayCellProps {
  value: number;
  row: UsageProductVariantTableRow;
  isLastElement: boolean;
  isInfinity: boolean;
  setTierValueByIndex: (index: number, value: Partial<PriceTier>) => void;
}

export function EditTiersTableDisplayCell({
  value,
  row,
  isLastElement,
  isInfinity,
  setTierValueByIndex,
}: EditTiersTableDisplayCellProps) {
  return (
    <Stack sx={{ alignItems: 'center', justifyContent: 'center', width: '100%' }} direction={'row'}>
      <span
        className="font-sans text-base text-black flex-1 text-center"
        style={{ paddingLeft: isLastElement && !isInfinity ? '30px' : undefined }}
      >
        {getToDisplayValue(value)}
      </span>
      {isLastElement && !isInfinity ? (
        <IconButton
          sx={{
            marginLeft: 'auto',
          }}
          onClick={() => setTierValueByIndex(row.index, { ...row, to: MAX_TO })}
          {...getSelectorAttribute(createPlanPageSelectors.products.usage.clearTierValueButton)}
        >
          <CloseIcon color="#8e9a9e" />
        </IconButton>
      ) : undefined}
    </Stack>
  );
}
